import type { ReactNode } from "react";
import { Navigate } from "react-router";
import type { ActionKey } from "@/auth/permission-actions";
import { useAccessStatus, useCan } from "@/hooks/use-can";
import { LoadingState, LOADING_STATE_VARIANT } from "@/components/base/loading-state/loading-state";

interface ProtectedRouteProps {
    action: ActionKey;
    children: ReactNode;
}

export function ProtectedRoute({ action, children }: ProtectedRouteProps) {
    const status = useAccessStatus();
    const canAccess = useCan(action);

    if (status === "loading") {
        return <LoadingState variant={LOADING_STATE_VARIANT.Block} label="Loading permissions" />;
    }

    if (!canAccess) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
}
